import { DateInput, TextInput } from '@core/components/Inputs';
import { SelectInput } from '@core/components/Select';
import FuseUtils from '@fuse/utils';
import { Divider, FormControl, Grid, Tooltip } from '@material-ui/core';
import { SelectCliente } from 'app/components/Select';
import SelectVenda from 'app/components/Select/SelectVenda';
import { ProdutoServicoList } from 'app/main/venda/components/VendaProdutoServico';
import { useFormikContext } from 'formik';
import moment from 'moment';
import NP from 'number-precision';
import React from 'react';
import { vendaFormStyles } from '../../../venda/components/modal/cadastro/styles';
import DadosEntregaNota from '../NotaFiscalDevolucao/DadosEntregaNota';

const NotaRemessaForm = () => {
  const formik = useFormikContext();
  const styles = vendaFormStyles();

  const { values, errors, touched, submitCount } = formik;

  const handleAddProdutoServico = () => {
    const { produtosServicos } = values;
    produtosServicos.push({ key: FuseUtils.generateGUID() });
    formik.setFieldValue('produtosServicos', produtosServicos);
  };

  const handleRemoveProdutoServico = (produtoServicoRemovido) => {
    calcularValorTotal(undefined, produtoServicoRemovido);
  };

  const calcularDesconto = (
    valorProdutoServico,
    dataVenda,
    promocaoVigenciaInicio,
    promocaoVigenciaFim,
    promocaoValor,
    promocaoTipo
  ) => {
    if (
      promocaoVigenciaInicio &&
      promocaoVigenciaFim &&
      moment(dataVenda).isSameOrAfter(promocaoVigenciaInicio) &&
      moment(dataVenda).isSameOrBefore(promocaoVigenciaFim)
    ) {
      if (promocaoTipo === 'VALOR') {
        valorProdutoServico -= promocaoValor;
      } else if (promocaoTipo === 'PERCENTUAL') {
        valorProdutoServico -= valorProdutoServico * (promocaoValor / 100);
      }
    }

    return valorProdutoServico || 0;
  };

  // RNE-369
  const calcularValorTotal = async (e, prodServRemovido) => {
    const id = e?.target?.id;
    const value = e?.target?.value;
    let valorTotal = 0;
    let valorTotalProdutoServico = 0;
    let habilitarTipoDesconto = false;

    // Calcular total de Produtos/Serviços
    if (id?.includes('.quantidade') || id?.includes('.valor') || !!prodServRemovido) {
      const index = parseInt(e?.target?.id?.substring(id?.indexOf(`[`) + 1, id?.indexOf(']')));
      for (let i = 0; i < values?.produtosServicos?.length || 0; ++i) {
        const produtoServico = values?.produtosServicos[i];

        if (!prodServRemovido || produtoServico?.key !== prodServRemovido.key) {
          const valor = (index === i && id.includes('valor') ? value : produtoServico?.valor) || 0;
          const quantidade = (index === i && id.includes('quantidade') ? value : produtoServico?.quantidade) || 0;

          const subtotal = NP.plus(valorTotalProdutoServico, NP.times(quantidade, valor));
          valorTotalProdutoServico = subtotal;

          if (subtotal > 0) {
            habilitarTipoDesconto = true;
          }
        }
      }
    } else {
      const verificarDesconto = id === 'data';

      for (let i = 0; i < values?.produtosServicos?.length || 0; ++i) {
        const produtoServico = values?.produtosServicos[i];
        const quantidade = produtoServico.quantidade || 0;
        let valor = produtoServico.valor || 0;

        if (verificarDesconto) {
          valor = calcularDesconto(
            produtoServico?.produtoServico?.valor,
            value,
            produtoServico?.produtoServico?.promocaoVigenciaInicio,
            produtoServico?.produtoServico?.promocaoVigenciaFim,
            produtoServico?.produtoServico?.promocaoValor,
            produtoServico?.produtoServico?.promocaoTipo
          );

          formik.setFieldValue(`produtosServicos[${i}].valor`, valor);
        }

        const subtotal = NP.plus(valorTotalProdutoServico, NP.times(quantidade, valor));
        valorTotalProdutoServico = subtotal;
        if (subtotal > 0) {
          habilitarTipoDesconto = true;
        }
      }
    }
    valorTotal = valorTotalProdutoServico;

    // Adicionar frete
    if (id === 'valorFrete') {
      valorTotal = NP.plus(valorTotal, value);
    } else if (values?.valorFrete) {
      valorTotal = NP.plus(valorTotal, values.valorFrete);
    }

    // Abater desconto
    if (
      habilitarTipoDesconto &&
      (values?.tipoDesconto || id === 'tipoDesconto') &&
      (values?.valorDesconto || id === 'valorDesconto')
    ) {
      const tipoDesconto = id === 'tipoDesconto' ? value : values.tipoDesconto;
      const valor = id === 'valorDesconto' ? (value ? e.target.value : 0) : values.valorDesconto;

      switch (tipoDesconto) {
        case 'PERCENTUAL': {
          const desconto = NP.times(valorTotal, NP.divide(valor, 100));
          valorTotal = NP.minus(valorTotal, desconto);
          break;
        }

        case 'VALOR': {
          valorTotal = NP.minus(valorTotal, valor);
          break;
        }

        default:
      }
    }

    formik.setFieldValue('valorTotal', valorTotal);

    // RNE-388
    formik.setFieldValue('habilitarTipoDesconto', habilitarTipoDesconto);
    if (!habilitarTipoDesconto) {
      formik.setFieldValue('tipoDesconto', undefined);
      formik.setFieldValue('habilitarDesconto', false);
      formik.setFieldValue('valorDesconto', undefined);
    }
  };

  const handleChangeProdutosServicos = async (e, key) => {
    formik.handleChange(e);
    const { id, value } = e?.target;

    if (id?.includes('quantidade') || id?.includes('valor')) {
      calcularValorTotal(e);
    } else {
      // RNE-387
      let habilitarFrete = false;
      for (let i = 0; i < values?.produtosServicos?.length || 0; ++i) {
        const produtoServico = values?.produtosServicos[i];

        if (produtoServico.key === key) {
          const [prefix] = e.target.id.split('.');

          if (e.target.value?.valor) {
            const valorProdutoServico = calcularDesconto(
              e.target.value.valor,
              formik.values.data,
              e.target.value?.promocaoVigenciaInicio,
              e.target.value?.promocaoVigenciaFim,
              e.target.value?.promocaoValor,
              e.target.value?.promocaoTipo
            );

            formik.setFieldValue(`${prefix}.valor`, valorProdutoServico);
            calcularValorTotal({ target: { id: `${prefix}.valor`, value: valorProdutoServico } });
          }

          formik.setFieldValue(`${prefix}.quantidade`, 1);
          formik.setFieldValue(`${prefix}.fiscal`, undefined);

          if (value?.produtoId) {
            habilitarFrete = true;
            break;
          }
        } else if (produtoServico?.produtoServico?.produtoId) {
          habilitarFrete = true;
        }
      }

      if (!habilitarFrete && values?.valorFrete > 0) {
        formik.setFieldValue('valorFrete', '');
        calcularValorTotal({ target: { id: 'valorFrete', value: 0 } });
      }

      formik.setFieldValue('habilitarFrete', habilitarFrete);
    }
  };

  const handleChangeTipoDesconto = (e) => {
    const event = { target: { id: 'tipoDesconto', value: e.target.value } };
    formik.handleChange(event);

    if (!e.target.value) {
      formik.setFieldValue('desconto', undefined);
      formik.setFieldValue('habilitarDesconto', false);
    } else {
      if (event.target.value === ' ') {
        formik.setFieldValue('valorDesconto', '');
      }

      formik.setFieldValue('habilitarDesconto', true);
    }

    calcularValorTotal(event);
  };

  const _errors = {
    destinatario: touched?.destinatario && errors?.destinatario,
    motivoRemessa: touched?.motivoRemessa && errors?.motivoRemessa,
    venda: touched?.venda && errors?.venda,
    previsaoEntrega: touched?.previsaoEntrega && errors?.previsaoEntrega,
    operacao: touched?.operacao && errors?.operacao,
  };

  const renderOperacao = () => {
    return (
      <SelectInput
        id="operacao"
        name="operacao"
        label="Operação"
        labelId="operacao-conta"
        onChange={(e) => {
          formik.setErrors({});
          formik.setTouched({});
          formik.handleChange(e);
        }}
        onBlur={formik.handleBlur}
        value={values?.operacao}
        error={_errors?.operacao}
        touched={!!_errors?.operacao}
        options={[
          { id: 'ENTRADA', title: 'Entrada' },
          { id: 'SAIDA', title: 'Saída' },
        ]}
        required
        disableClearable
      />
    );
  };

  return (
    <>
      <Grid container spacing={3} className="mt-16  mb-16">
        <Grid item lg={4} md={4} xs={6}>
          <FormControl variant="outlined" style={{ width: '100%' }}>
            <SelectInput
              id="motivoRemessa"
              name="motivoRemessa"
              label="Motivo da remessa"
              labelId="motivo-remessa"
              onChange={(e) => {
                formik.setErrors({});
                formik.setTouched({});
                formik.handleChange(e);
              }}
              onBlur={formik.handleBlur}
              value={values?.motivoRemessa}
              error={_errors?.motivoRemessa}
              touched={!!_errors?.motivoRemessa}
              options={[
                { id: 'AMOSTRA_GRATIS', title: 'Amostra grátis' },
                { id: 'ATIVO_USO_FORA_ESTABELECIMENTO', title: 'Ativo imobilizado para uso fora do estabelecimento' },
                { id: 'BRINDES', title: 'Brindes' },
                { id: 'CONSIGNACAO', title: 'Consignação' },
                { id: 'DEMONSTRACAO', title: 'Demonstração' },
                { id: 'DOACOES', title: 'Doações' },
                { id: 'ENTREGA_FUTURA', title: 'Entrega futura' },
                {
                  id: 'INDUSTRIALIZACAO',
                  title:
                    'Industrialização (caso de transformação da matéria-prima em uma unidade diferente da empresa)',
                },
                { id: 'PRODUTOS_CONSERTO_MANUTENCAO', title: 'Produtos em conserto ou manutenção' },
                { id: 'PRODUTOS_EXPOSICOES', title: 'Produtos para exposições e feiras' },
                { id: 'TRANSFERENCIA_UNIDADE', title: 'Transferências de unidade' },
                { id: 'VENDA_FORA_ESTABELECIMENTO', title: 'Venda fora do estabelecimento' },
              ]}
              required
              disableClearable
            />
          </FormControl>
        </Grid>
        <Grid item lg={2} md={2} xs={6}>
          <Tooltip
            title='A operação "Entrada" adiciona itens no estoque e, a operação "Saída" remove os itens do estoque.'
            placement="top"
          >
            <FormControl variant="outlined" style={{ width: '100%' }}>
              <>{renderOperacao()}</>
            </FormControl>
          </Tooltip>
        </Grid>
        <Grid item lg={6} md={6} xs={6}>
          <Tooltip title="Caso a nota de remessa esteja vinculada a alguma venda, informe-a aqui." placement="top">
            <FormControl variant="outlined" style={{ width: '100%' }}>
              <SelectVenda
                id="venda"
                name="venda"
                label="Vincular à venda"
                value={values?.venda}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={_errors.venda}
                touched={!!_errors.venda}
                soVendasAprovadas
              />
            </FormControl>
          </Tooltip>
        </Grid>
        <Grid item lg={6} md={6} xs={6}>
          <SelectCliente
            id="destinatario"
            idObject="destinatario"
            label="Destinatário"
            required
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={values?.destinatario}
            touched={!!_errors.destinatario}
            error={_errors.destinatario}
          />
        </Grid>
        <Grid item lg={6} md={6} xs={6}>
          <DateInput
            id="previsaoEntrega"
            name="previsaoEntrega"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={values?.previsaoEntrega}
            error={!!_errors.previsaoEntrega}
            helperText={_errors.previsaoEntrega}
            touched={touched?.previsaoEntrega}
            fullWidth
            variant="outlined"
            label="Previsão de entrega"
          />
        </Grid>
      </Grid>
      <ProdutoServicoList
        id="produtosServicos"
        value={values?.produtosServicos}
        onChange={handleChangeProdutosServicos}
        onBlur={formik.handleBlur}
        handleAddProdutoServico={handleAddProdutoServico}
        handleRemoveProdutoServico={handleRemoveProdutoServico}
        errors={errors}
        touched={touched}
        submitCount={submitCount}
        aceitaProdutoImobilizado
        exibeMsgProdutoSemEstoque={values.operacao !== 'ENTRADA'}
        soProduto
      />

      <Divider className={styles.divider} />

      <DadosEntregaNota
        values={values}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        calcularValorTotal={calcularValorTotal}
        handleChangeTipoDesconto={handleChangeTipoDesconto}
        styles={styles}
        errors={errors}
        touched={touched}
        submitCount={submitCount}
      />

      <Grid item lg={12} md={12} xs={12}>
        <TextInput
          id="informacoesComplementares"
          name="informacoesComplementares"
          label="Informações Complementares"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={values?.informacoesComplementares}
          maxLength={500}
          fullWidth
          multiline
          rows={3}
          variant="outlined"
        />
      </Grid>
    </>
  );
};

export default NotaRemessaForm;
